module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_5010.8102698a.png";